import { render, staticRenderFns } from "./agendamentotarefa.vue?vue&type=template&id=23662eef&"
import script from "./agendamentotarefa.vue?vue&type=script&lang=js&"
export * from "./agendamentotarefa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports